// IMPORTS
// Components
import OHSWidget from './OHSWidget';
// Assets
import './../scss/OHSTiles.scss';


// COMPONENT
export default function OHSTiles (props) {
   // States and Variables
   const containerID = 'ohstiles-' + Math.floor(Math.random() * 999999);

   // Component
   return (
      <div id={props.id} className='ohstiles'>
         {props.content && props.content.length > 0 && props.content.map(function (item, i) {
            return (
               <OHSWidget onehive={props.onehive} key={`${containerID}-container-${i}`} title={item.title}>
                  {item.content}
               </OHSWidget>
            );
         })}
      </div>
   );
}